import { makeAutoObservable } from 'mobx';
import { AssignmentSettingApiResponse } from '../../../api/RuleApi';

export class AssignmentSetting {
  id: number = -1;
  ncExternalId: string = '';
  trackingCategories: Map<string, string> = new Map();
  apportionmentId: number = -1;
  ignore: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: AssignmentSettingApiResponse): AssignmentSetting {
    const setting = new AssignmentSetting();

    setting.id = apiData.id;
    setting.ncExternalId = apiData.ncExternalId;
    setting.trackingCategories = new Map(
      (apiData.trackingCategories || []).map(tc => [
        tc.split(':')[0],
        tc.split(':')[1],
      ])
    );
    setting.apportionmentId = apiData.apportionmentId;
    setting.ignore = apiData.ignore;

    return setting;
  }

  toApi = (): AssignmentSettingApiResponse => ({
    id: this.id,
    ncExternalId: this.ncExternalId,
    trackingCategories: [...this.trackingCategories.entries()].map(
      tc => `${tc[0]}:${tc[1]}`
    ),
    apportionmentId: this.apportionmentId > 0 ? this.apportionmentId : null,
    ignore: this.ignore,
  });

  setTrackingCategory(typeId: string, nameId: string) {
    this.trackingCategories.set(typeId, nameId);
  }

  isEmpty(): boolean {
    return (
      this.ncExternalId == '' &&
      this.trackingCategories.size == 0 &&
      this.apportionmentId == -1 &&
      this.ignore == false
    );
  }
}
